// SEO copy is built directly from the client-provided keyword research
// ("KaveriBiz – Google Search Keyword Strategy"): buyer-intent service+location
// searches like "trade license consultant Bangalore", "FSSAI license consultant
// Bangalore", "trademark registration consultant Bangalore", etc.

export const SITE_URL = "https://www.kaveribiz.com";
export const SITE_NAME = "KaveriBiz Corporate Services";
export const SITE_PHONE = "+91-88671-92221";
export const SITE_CITY = "Bangalore";
export const SITE_REGION = "Karnataka";

// "6. Location Variations to Test" from the keyword doc — used for the
// LocalBusiness areaServed schema and the on-page "Areas We Serve" section.
export const AREAS_SERVED = [
  "Bangalore", "Bengaluru", "Karnataka", "Whitefield", "Electronic City",
  "Hosur Road", "Peenya", "Yelahanka", "Devanahalli", "Bommasandra",
];

// Default (non-overridden) meta content per static route.
export const PAGE_SEO = {
  "/": {
    title: "Trade License, FSSAI & Business Registration Consultant in Bangalore | KaveriBiz",
    description:
      "KaveriBiz is a Bangalore-based compliance consultant for trade license registration, FSSAI licensing, labour compliance, business registration, trademark and more. Free consultation.",
  },
  "/about": {
    title: "About KaveriBiz | Corporate Compliance Consultants in Bangalore",
    description:
      "KaveriBiz Corporate Services LLP is a Bangalore compliance, licensing and legal advisory firm trusted by 500+ businesses across 14+ regulatory verticals.",
  },
  "/services": {
    title: "Business License & Compliance Consultant Services in Bangalore | KaveriBiz",
    description:
      "Trade license, Shops & Establishment, FSSAI, labour compliance, trademark registration, property documentation and more — every licence your Bangalore business needs, one partner.",
  },
  "/process": {
    title: "Our Process | How KaveriBiz's Bangalore Compliance Consulting Works",
    description:
      "From your first call to a completed licence or registration — see how KaveriBiz's Bangalore-based compliance team manages the entire process for you.",
  },
  "/contact": {
    title: "Contact a Business License Consultant in Bangalore | KaveriBiz",
    description:
      "Get in touch with KaveriBiz for trade license, FSSAI, labour compliance or trademark registration in Bangalore — Whitefield, Electronic City, Peenya, Yelahanka and beyond.",
  },
};

// Keyword-mapped title/description per service slug — sourced from the keyword
// doc's "High-Intent License Searches", "Compliance Searches" and "IP Searches"
// groups. Falls back to the service's own title/tagline if a slug isn't listed.
export const SERVICE_SEO = {
  "business-registration": {
    title: "Business Registration Consultant Bangalore | Company Incorporation | KaveriBiz",
    description:
      "Private Limited, LLP, OPC, Partnership and Proprietorship registration in Bangalore — plus PAN, TAN, DIN, UDYAM and Startup India. New business compliance consultant Bangalore.",
    keywords: ["business registration consultant Bangalore", "consultant for new business Bangalore", "startup compliance consultant Bangalore"],
  },
  "corporate-secretarial-roc": {
    title: "Corporate Secretarial & ROC Compliance Consultant Bangalore | KaveriBiz",
    description:
      "Annual ROC filing, LLP compliance, board meetings and secretarial due diligence for Bangalore companies — company compliance consultant you can rely on year-round.",
    keywords: ["company compliance consultant Bangalore", "statutory compliance consultant Bangalore"],
  },
  "labour-law": {
    title: "Labour Law & Statutory Compliance Consultant Bangalore | KaveriBiz",
    description:
      "Labour law compliance, EPF & ESI, POSH, contract labour and HR compliance for Bangalore businesses — annual labour compliance consultant trusted by 500+ companies.",
    keywords: ["labour law compliance consultant Bangalore", "labour compliance services Bangalore", "HR compliance consultant Bangalore", "POSH compliance consultant Bangalore", "contract labour compliance consultant Bangalore"],
  },
  "industrial-licensing": {
    title: "Trade License Consultant Bangalore | Industrial Licensing | KaveriBiz",
    description:
      "Trade license registration, boiler, electrical, petroleum and warehouse licensing in Bangalore — from application to renewal, handled end-to-end.",
    keywords: ["trade license consultant Bangalore", "trade license registration Bangalore", "business license consultant Bangalore"],
  },
  "food-business-fssai": {
    title: "FSSAI License Consultant Bangalore | Food Business Registration | KaveriBiz",
    description:
      "FSSAI Basic, State and Central licensing plus food labelling compliance for restaurants, cloud kitchens and food manufacturers in Bangalore.",
    keywords: ["FSSAI license consultant Bangalore"],
  },
  "legal-metrology": {
    title: "Legal Metrology Registration Consultant Bangalore | KaveriBiz",
    description:
      "Manufacturer, importer and packer registration, weights & measures approval and packaged commodity compliance for Bangalore businesses.",
    keywords: ["legal metrology registration Bangalore"],
  },
  "fire-environmental": {
    title: "Fire NOC & Environmental Clearance Consultant Bangalore | KaveriBiz",
    description:
      "Fire NOC, Consent to Establish/Operate and environmental clearance for Bangalore business premises — factory compliance consultant Karnataka.",
    keywords: ["fire NOC consultant Bangalore", "factory compliance consultant Karnataka"],
  },
  "property-legal": {
    title: "Property Registration & Khata Transfer Consultant Bangalore | KaveriBiz",
    description:
      "Khata transfer, property registration, encumbrance certificate, legal heir certificate and property due diligence — property documentation lawyer Bangalore.",
    keywords: ["khata transfer consultant Bangalore", "property registration consultant Bangalore", "property due diligence lawyer Bangalore", "legal heir certificate consultant Bangalore"],
  },
  "intellectual-property": {
    title: "Trademark Registration Consultant Bangalore | IP Lawyer | KaveriBiz",
    description:
      "Trademark registration, objection replies, renewals and copyright registration in Bangalore — brand registration consultant for growing businesses.",
    keywords: ["trademark registration consultant Bangalore", "trademark lawyer Bangalore", "trademark objection reply lawyer Bangalore", "copyright registration consultant Bangalore"],
  },
  "contracts": {
    title: "Business Contract Drafting Consultant Bangalore | KaveriBiz",
    description:
      "Vendor, employment, NDA, shareholder and JV agreements drafted and reviewed by Bangalore corporate legal advisors.",
    keywords: ["business contract consultant Bangalore"],
  },
  "corporate-advisory": {
    title: "Corporate Compliance Advisory Bangalore | KaveriBiz",
    description:
      "Compliance audits, compliance calendars and legal opinions for SMEs and startups in Bangalore — SME compliance consultant Bangalore.",
    keywords: ["SME compliance consultant Bangalore", "new business compliance consultant Bangalore"],
  },
  "due-diligence-transactions": {
    title: "Due Diligence & M&A Advisory Consultant Bangalore | KaveriBiz",
    description:
      "Legal, financial, secretarial and IP due diligence plus M&A and share purchase advisory for Bangalore transactions.",
    keywords: ["due diligence consultant Bangalore"],
  },
  "import-export-customs": {
    title: "IEC Registration & Import Export Consultant Bangalore | KaveriBiz",
    description:
      "IEC registration, DGFT compliance and customs advisory for import/export businesses based in Bangalore.",
    keywords: ["IEC registration consultant Bangalore"],
  },
  "annual-compliance": {
    title: "Annual Compliance Package Bangalore | KaveriBiz",
    description:
      "One subscription covering ROC, GST, labour, trade licence, FSSAI and fire NOC renewals — annual compliance consultant Bangalore.",
    keywords: ["annual labour compliance Bangalore", "statutory compliance consultant Bangalore"],
  },
  "hr-services": {
    title: "HR Outsourcing Services Bangalore | Payroll & Recruitment | KaveriBiz",
    description:
      "KaveriBiz HR Services covers recruitment & onboarding, attendance & leave, payroll & payslips, HR policies, exit documentation and monthly HR compliance reports for Bangalore businesses.",
    keywords: ["HR outsourcing services Bangalore", "payroll services consultant Bangalore", "HR compliance consultant Bangalore", "recruitment agency Bangalore"],
  },
};

// AEO/GEO content: short, direct, quotable Q&A pairs answer-engines and
// featured snippets can lift verbatim. Grounded in what's actually true about
// the business (no invented prices/timelines) per the keyword doc's intent groups.
export const FAQS = [
  {
    q: "Does KaveriBiz offer trade license registration in Bangalore?",
    a: "Yes. KaveriBiz handles trade license registration and renewal for businesses across Bangalore, including Whitefield, Electronic City, Peenya and Yelahanka, from application to final approval.",
  },
  {
    q: "How much does trade license or FSSAI registration cost in Bangalore?",
    a: "Government fees vary by licence category, business scale and location, and professional fees depend on the scope of work. KaveriBiz gives you an exact, fixed-fee quote after a free initial consultation — no hidden charges.",
  },
  {
    q: "Do I need a Shops & Establishment licence for a small business in Bangalore?",
    a: "Most commercial establishments in Karnataka, including small shops and offices, are required to register under the Karnataka Shops & Establishments Act. KaveriBiz can confirm your exact obligation and complete the registration for you.",
  },
  {
    q: "What labour law compliances apply to a company in Karnataka?",
    a: "Depending on headcount and sector, this can include EPF & ESI registration, Shops & Establishments compliance, contract labour licensing, POSH policy implementation and annual statutory filings. KaveriBiz runs a compliance audit to identify exactly what applies to you.",
  },
  {
    q: "How do I register a trademark in Bangalore?",
    a: "Trademark registration involves a clearance search, filing the application with the Trademark Registry, responding to any examination objections, and monitoring through to registration. KaveriBiz manages the entire process, including objection replies and renewals.",
  },
  {
    q: "Which areas in Bangalore does KaveriBiz serve?",
    a: "KaveriBiz serves businesses across Bangalore/Bengaluru and Karnataka, including Whitefield, Electronic City, Hosur Road, Peenya, Yelahanka, Devanahalli and Bommasandra, with remote and on-site support.",
  },
  {
    q: "What documents are needed for business registration in Bangalore?",
    a: "Typical requirements include identity and address proof of promoters, proof of registered office, PAN, and business-specific documents depending on the entity type (Private Limited, LLP, Partnership or Proprietorship). KaveriBiz provides a checklist specific to your business during the free consultation.",
  },
];

export function getServiceSeo(service) {
  const override = SERVICE_SEO[service.slug];
  return {
    title: override?.title || `${service.title} in Bangalore | KaveriBiz`,
    description: override?.description || `${service.tagline} Serving Bangalore, Karnataka.`,
    keywords: override?.keywords || [],
  };
}

export function organizationJsonLd() {
  return {
    "@context": "https://schema.org",
    "@type": "LegalService",
    "name": SITE_NAME,
    "url": SITE_URL,
    "logo": `${SITE_URL}/kaveribiz_logo.png`,
    "image": `${SITE_URL}/kaveribiz_logo.png`,
    "telephone": SITE_PHONE,
    "email": "info@kaveribiz.com",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": SITE_CITY,
      "addressRegion": SITE_REGION,
      "addressCountry": "IN",
    },
    "areaServed": AREAS_SERVED.map((name) => ({ "@type": "Place", name })),
    "priceRange": "$$",
  };
}

export function breadcrumbJsonLd(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, i) => ({
      "@type": "ListItem",
      "position": i + 1,
      "name": item.name,
      "item": `${SITE_URL}${item.path}`,
    })),
  };
}

export function serviceJsonLd(service) {
  const seo = getServiceSeo(service);
  return {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": service.title,
    "name": seo.title,
    "description": seo.description,
    "provider": { "@type": "LegalService", "name": SITE_NAME, "url": SITE_URL },
    "areaServed": AREAS_SERVED.map((name) => ({ "@type": "Place", name })),
    "url": `${SITE_URL}/services/${service.slug}`,
  };
}

export function faqJsonLd(faqs) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map((f) => ({
      "@type": "Question",
      "name": f.q,
      "acceptedAnswer": { "@type": "Answer", "text": f.a },
    })),
  };
}
